export default "__VITE_ASSET__a8dbb139__"